export interface Program {
	Id: number;
	TypeId: number;
	Type: string;
	Name: string;
	Beneficiaries: string[];
	Coaches: string[];
	DateCreatedUtc: string;
}

export class CreateProgramModel {
	Name: string;
	TypeId: number;
}

export class EditProgramModel extends CreateProgramModel {
	Id: number;
	constructor(item?: Program) {
		super();
		this.Id = item && item.Id;
		this.Name = item && item.Name;
		this.TypeId = item && item.TypeId;
	}
}

export class CreateCoachModel {
	coachId: string;
	programId: number;
}

export interface Beneficiary {
	BeneficiaryId: string;
	Name: string;
	ProgramId: number;
	BusinessName: string;
	BusinessDescription: string;
	KeyServices: string;
	EmployeeCount: number;
	CurrentRevenue: number;
	ProgramParticipation: boolean;
	DateCreatedUtc: string;
	CreatedByUserId: string;
}


export class BeneficiaryModel {
	UserId: string;
	ProgramId: number;
	BusinessName: string;
	BusinessDescription: string;
	KeyServices: string;
	EmployeeCount: number;
	CurrentRevenue: number;
	ProgramParticipation: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/program.ts